module.exports = __webpack_public_path__ + "media/video-mobile.97b3801d.mp4";